import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//service imports
import { UtilityService } from '../../../core/services/utility.service';
import { ChecklistService } from 'src/app/pages/checklist/services/checklist.service';

@Component({
  selector: 'app-distribute-checklists-modal',
  templateUrl: './distribute-checklists-modal.component.html',
  styleUrls: ['./distribute-checklists-modal.component.css'],
})
export class DistributeChecklistsModalComponent implements OnInit {
  @ViewChild('notificationForm', { static: false }) notificationForm: NgForm;
  @Input() checklists: any;
  @Input() mode: any;
  formData: { [key: string]: any } = {};
  validComboDrag: any;
  dragFiles: any;
  fileData: any[] = [];
  newFiles: any[] = [];
  innerCounter = 0;
  emailSendWait = false;
  alert: any;
  emailList: any[];
  templateCategoryIDs: { [key: string]: number } = { C: 1, O: -1, P: -2, H: -4 };

  constructor(
    public activeModal: NgbActiveModal,
    private utilityService: UtilityService,
    private checklistService: ChecklistService
  ) {}

  ngOnInit(): void {
    this.formData.ToEmail = [];
    this.generateFilenames();
  }

  generateFilenames() {
    this.checklists.forEach((val: any) => {
      if (val.InspectedOnDisplay != null)
        val.Filename =
          val['Checklist_Type'].replace(/[^a-zA-z\d]/g, '') +
          '_' +
          val.InspectedOnDisplay.replace(/\//g, '_') +
          '_' +
          val.ChecklistInstanceID +
          '.pdf';
      else val.Filename = val['Checklist_Type'].replace(/[^a-zA-z\d]/g, '') + '_' + val.ChecklistInstanceID + '.pdf';
    });
  }

  deleteAttachment(file: any) {
    var index = this.newFiles.indexOf(file);
    this.newFiles.splice(index, 1);
    if (this.newFiles.length == 0) this.newFiles.push({ File: null, Filename: null });
  }

  private readFile(file: any, call: any) {
    var reader = new FileReader();
    reader.onload = function (e) {
      return call(e, file.name);
    };
    reader.readAsDataURL(file);
  }

  upload() {
    this.fileData = [];
    var currentUpload = this.formData.fileDrop;
    this.formData.fileDrop = [];
    for (var i = 0; i < currentUpload.length; i++) {
      currentUpload[i].nameEdit = this.utilityService.formatAttachmentName(currentUpload[i].name);
    }

    if (currentUpload != null) {
      for (var i = 0; i < currentUpload.length; i++) {
        var n = 0;
        this.innerCounter = 0;
        this.readFile(currentUpload[i], (e: any, fileName: string) => {
          setTimeout(() => {
            this.fileData.push({ data: e.target.result.toString().split(','), size: e.total, name: fileName });
            if (n == currentUpload.length - 1) {
              this.fileData.forEach((val: any) => {
                currentUpload.forEach((val2: any) => {
                  if (val2.size == val.size && val.name == val2.name) {
                    this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split('/')[0] });
                  }
                });
              });
            }
            n++;
          });
        });
      }
    }
  }

  sendClicked() {
    this.emailSendWait = true;
    var checklistInstanceIDs = [];
    var templateID = [];
    var filenames = [];
    var newFilenames = [];
    var newFiles = [];
    var toEmail = [];
    this.formData.ToEmail.forEach((val: any) => {
      if (val != null) toEmail.push(val.EmailAddress);
    });
    this.checklists.forEach((val: any) => {
      checklistInstanceIDs.push(val['ChecklistInstanceID']);
      templateID.push(val['ChecklistTemplateID']);
      filenames.push(val.Filename);
    });
    this.newFiles.forEach((val: any) => {
      if (val.Filename && val.File) {
        newFilenames.push(val.Filename);
        newFiles.push(val.File);
      }
    });
    this.checklistService
      .sendChecklists(
        checklistInstanceIDs,
        filenames,
        null,
        toEmail,
        this.formData.Subject,
        this.formData.Message,
        newFilenames,
        newFiles,
        templateID,
        null,
        null,
        null,
        null,
        this.templateCategoryIDs[this.mode]
      )
      .then((response: any) => {
        if (response.success) {
          this.alert = { type: 'success', msg: (this.mode == 'C' ? 'Checklists' : 'Action Items') + ' sent successfully.' };
          this.emailSendWait = false;
        } else {
          this.alert = { type: 'danger', msg: response.error };
          this.emailSendWait = false;
        }
      });
  }

  closeClicked() {
    this.activeModal.close('close');
  }

  closeAlert() {
    this.alert = null;
  }
}
